var CHAR_CODES;
(function (CHAR_CODES) {
    CHAR_CODES[CHAR_CODES["ENTER"] = 13] = "ENTER";
    CHAR_CODES[CHAR_CODES["SPACE"] = 32] = "SPACE";
})(CHAR_CODES || (CHAR_CODES = {}));
const handleKeyDown = (keyCode, handler) => (event) => {
    if (event.keyCode === keyCode) {
        event.preventDefault();
        handler();
    }
};
export const handleSpaceKeyDown = (handler) => (event) => handleKeyDown(CHAR_CODES.SPACE, handler)(event);
export const handleKeyPressEnterOrSpace = (handler) => (event) => {
    if (event.key === ' ' || event.key === 'Enter') {
        handler(event);
    }
};
export const focusElement = ({ selector, canFocus = false, preventScroll = false }) => {
    const element = document.querySelector(selector);
    if (element) {
        !canFocus && element.setAttribute('tabindex', '-1');
        element.focus({ preventScroll });
    }
};
export const scrollElementIntoView = (selector, scrollOptions = {}) => {
    document.querySelector(selector)?.scrollIntoView(scrollOptions);
};
export const addCircularTabFocus = (firstElementSelector, lastElementSelector) => {
    const first = document.querySelector(firstElementSelector);
    const last = document.querySelector(lastElementSelector);
    if (first && last) {
        const firstListener = (event) => {
            if (event.keyCode === 9 && event.shiftKey) {
                event.preventDefault();
                last.focus();
            }
        };
        const lastListener = (event) => {
            if (event.keyCode === 9 && !event.shiftKey) {
                event.preventDefault();
                first.focus();
            }
        };
        first.addEventListener('keydown', firstListener);
        last.addEventListener('keydown', lastListener);
        return () => {
            first.removeEventListener('keydown', firstListener);
            last.removeEventListener('keydown', lastListener);
        };
    }
    return null;
};
export const hookToAttributeSelector = (hook, options) => {
    const { hookKey = 'data-hook', componentId } = options || {};
    return componentId ? `#${componentId} [${hookKey}="${hook}"]` : `[${hookKey}="${hook}"]`;
};
